import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../Config/api';

export default function ActivatePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error

  const calledOnceRef = useRef(false); // blocco doppio effetto


  const activateAccount = async () => {
    setStatus('loading');
    try {
      const res = await fetch(API_ENDPOINTS.activateAccountByToken, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      if (res.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (e) {
      setStatus('error');
    }
  };

  useEffect(() => {
    if (!calledOnceRef.current) {
      calledOnceRef.current = true;
      activateAccount();
    }
  }, []);

console.log(status);


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md text-center space-y-6">
        {status === 'loading' && (
          <>
            <p className="text-gray-700 text-lg">Attivazione in corso...</p>
            <div className="animate-spin h-6 w-6 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
          </>
        )}

        {status === 'success' && (
          <>
            <h2 className="text-xl font-bold text-green-600">Account attivato!</h2>
            <p className="text-gray-600">Ora puoi impostare la tua password.</p>
            <button
              onClick={() => navigate(`/reset-password/${token}`)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
            >
              Continua
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className="text-xl font-bold text-red-600">Errore di attivazione</h2>
            <p className="text-gray-600">Il link potrebbe essere scaduto o già usato.</p>
            <button
              onClick={activateAccount}
              className="mt-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded"
            >
              Riprova
            </button>
          </>
        )}
      </div>
    </div>
  );
}
